import z from 'zod';

export const DailyRewardStatusSchema = z.enum([
  'Awarded',
  'Pending',
  'NotAvailable',
]);

export const DailyRewardSchema = z.object({
  playerRewardId: z.number().optional(),
  rewardType: z.string().optional(),
  type: z.string().optional(),
  rewardAmount: z.number().optional(),
  availableAtLoyaltyStatus: z.string().optional(),
  awardedAt: z.string().optional(),
  expiryDate: z.string().optional(),
  nextAvailableAt: z.string().optional(),
  status: DailyRewardStatusSchema,
});

export const DailyRewardsResponseSchema = z.object({
  dailyRewards: z.array(DailyRewardSchema),
});
